<template>
  <!-- 新增问卷 -->
  <el-dialog
    title="编辑问卷"
    :visible.sync="dialogWj"
    :beforeClose="beforeClose"
    width="700px"
  >
    <el-form
      class="wj-form"
      ref="wjForm"
      :rules="wjrules"
      :model="wjform"
      label-width="125px"
      size="small"
    >
      <el-form-item label="问卷类型" prop="surveyType">
        <el-select v-model="wjform.surveyType" placeholder="请选择">
          <el-option
            v-for="item in surveyTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="wjform.surveyType === 'zdy'"
        label="自定义名称"
        prop="customSurvey"
      >
        <el-input v-model="wjform.customSurvey" style="width: 400px"></el-input>
      </el-form-item>
      <el-button
        type="text"
        class="el-icon-plus"
        style="margin-left: 20px"
        @click="addQs"
        >添加问题</el-button
      >
      <div
        class="topic"
        v-for="(item, index) in wjform.questionDTOS"
        :key="item.id"
      >
        <div class="num">
          <span>{{ index + 1 }}</span>
        </div>
        <el-form-item label="问题">
          <el-input
            v-model="item.question"
            maxlength="100"
            style="width: 400px"
          ></el-input>
          <el-button
            type="text"
            class="el-icon-close"
            style="margin-left: 15px; color: red"
            @click="delQs(item.id)"
            >删除问题</el-button
          >
        </el-form-item>
        <el-form-item label="问题类型">
          <el-radio-group v-model="item.quesType">
            <el-radio label="lonely">单选</el-radio>
            <el-radio label="more">多选</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="选项">
          <el-button
            type="text"
            class="el-icon-plus"
            style="margin-left: 10px"
            @click="addOption(item.id)"
            >添加选项</el-button
          >
          <div
            class="xuanxiang"
            v-for="(i, index) in item.quesOption"
            :key="i.id"
          >
            {{ i.order }}：
            <el-input
              v-model="i.desc"
              style="width: 300px"
              maxlength="100"
            ></el-input>
            <el-button
              v-if="
                i.id == item.quesOption[item.quesOption.length - 1].id &&
                index != 0
              "
              type="text"
              class="el-icon-close"
              style="margin-left: 15px; color: red"
              @click="delOption(item.id, i.id)"
              >移除选项</el-button
            >
          </div>
        </el-form-item>
      </div>

      <div>
        <el-button class="sub-btn" type="primary" size="small" @click="subWj"
          >保 存</el-button
        >
      </div>
    </el-form>
  </el-dialog>
</template>
<script>
export default {
  props: {
    dialogWj: {
      type: Boolean,
      default: false
    },
    surveyTypeOptions: {
      type: Array
    },
    wjformPro: {
      type: Object
      // default:{
      // 	surveyType: "",
      // 	customSurvey: "",
      // 	questionDTOS: [
      // 		{
      // 			id: 1,
      // 			question: "",
      // 			quesType: "lonely",
      // 			quesOption: [{ id: 1, order: "A", desc: "" }]
      // 		}
      // 	]
      // }
    }
  },

  data() {
    return {
      wjform: '',
      wjrules: {
        surveyType: [
          { required: true, message: '请选择问卷类型', trigger: 'blur' }
        ],
        customSurvey: [
          { required: true, message: '请输入自定义名称', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    //this.init();
    this.wjform = this.wjformPro
  },
  methods: {
    //添加问题
    addQs() {
      this.wjform.questionDTOS.push({
        id: new Date().getTime(),
        question: '',
        quesType: 'lonely',
        quesOption: [{ id: 1, order: 'A', desc: '' }]
      })
    },
    //删除问题
    delQs(id) {
      this.wjform.questionDTOS = this.wjform.questionDTOS.filter(
        (i) => i.id != id
      )
      console.log('删除问题')
    },
    //添加选项
    addOption(id) {
      // A:65
      let curTopic = this.wjform.questionDTOS.find((i) => i.id == id)
      curTopic.quesOption.length < 20 &&
        curTopic.quesOption.push({
          id: new Date().getTime(),
          order: String.fromCharCode(65 + curTopic.quesOption.length),
          desc: ''
        })
    },
    //删除选项
    delOption(topId, quesId) {
      let curTopic = this.wjform.questionDTOS.find((i) => i.id == topId)
      curTopic.quesOption = curTopic.quesOption.filter((i) => i.id != quesId)
    },
    //提交问卷
    async subWj() {
      try {
        await this.$refs.wjForm.validate()

        let questionList = this.wjform.questionDTOS.map((i) => i.question)
        let quesOptionList = []
        this.wjform.questionDTOS.forEach((item) => {
          item.quesOption.forEach((i) => {
            quesOptionList.push(i.desc)
          })
        })
        if (
          this.wjform.questionDTOS.length === 0 ||
          questionList.some((i) => i.length === 0) ||
          quesOptionList.some((i) => i.length === 0)
        ) {
          this.$message.error('请完善问卷信息！')
          return
        }
        this.wjform.questionDTOS = this.wjform.questionDTOS
        this.$emit('surveyChange', this.wjform)
        this.$emit('dialogWjClose')
      } catch (err) {
        console.log('err', err)
      }
    },
    beforeClose() {
      this.$emit('dialogWjClose')
    }
  },
  watch: {}
}
</script>
<style lang="less" scoped>
.wj-form {
  margin-top: -15px;
  .topic {
    border-bottom: 1px solid #eee;
    border-top: 1px solid #eee;
    padding-top: 15px;
    .num {
      position: relative;
      top: 0px;
      left: 0px;
      span {
        position: absolute;
        top: -10px;
        left: 20px;
        font-size: 23px;
        color: rgb(107, 101, 101);
      }
    }
  }
  .xuanxiang {
    // border: 1px solid #000;
    margin-bottom: 8px;
  }
  .sub-btn {
    margin-top: 20px;
    margin-left: 280px;
  }
}
</style>